import type { ResolvedReward } from "../systems/RewardResolver.js";
import {
  toRewardLineItems,
  type RewardLineItem,
  type RewardShape,
} from "../systems/rewardLineItems.js";

/** RewardModalPresenter가 도메인 보상 집계 helper를 직접 호출하지 않도록 분리한 UI-facing 데이터 builder. */
export type { RewardLineItem, RewardShape };

export function buildRewardModalItems(
  reward: ResolvedReward,
  instances: readonly RewardShape[] = [],
): RewardLineItem[] {
  return toRewardLineItems(reward, instances);
}
